(() => {
  const selector = '[data-lonevile-arms-scroll]';
  const mobileQuery = window.matchMedia('(max-width: 699px)');
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  let sections = [];
  let animationFrame = 0;

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const update = () => {
    animationFrame = 0;

    const viewportHeight = Math.max(window.innerHeight, 1);
    const startScale = mobileQuery.matches ? 1.06 : 1.08;

    sections.forEach((section) => {
      if (motionQuery.matches) {
        section.style.setProperty('--lonevile-arms-scroll-scale', '1');
        return;
      }

      const rect = section.getBoundingClientRect();
      const progress = clamp(
        (viewportHeight - rect.top) / (viewportHeight + rect.height),
        0,
        1
      );
      const scale = startScale - (startScale - 1) * progress;

      section.style.setProperty(
        '--lonevile-arms-scroll-scale',
        scale.toFixed(4)
      );
    });
  };

  const scheduleUpdate = () => {
    if (animationFrame) return;
    animationFrame = requestAnimationFrame(update);
  };

  const resolveSections = () => {
    sections = Array.from(document.querySelectorAll(selector));
    scheduleUpdate();
  };

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });

  if (typeof motionQuery.addEventListener === 'function') {
    motionQuery.addEventListener('change', scheduleUpdate);
    mobileQuery.addEventListener('change', scheduleUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resolveSections, { once: true });
  } else {
    resolveSections();
  }

  document.addEventListener('shopify:section:load', resolveSections);
})();
